import { useMemo } from 'react';
import { useServices } from '@/app/providers';
import {
  createDateFormatter,
  DEFAULT_DATE_FORMATTER_CONFIG,
  type DateFormatterResult,
} from '@yawi/infrastructure';

export const useDateFormatter = (): DateFormatterResult => {
  const { systemSettings } = useServices();

  return useMemo(
    () =>
      createDateFormatter({
        dateFormat:
          systemSettings?.dateFormat || DEFAULT_DATE_FORMATTER_CONFIG.dateFormat,
        timeFormat:
          systemSettings?.timeFormat || DEFAULT_DATE_FORMATTER_CONFIG.timeFormat,
        timezone:
          systemSettings?.timezone || DEFAULT_DATE_FORMATTER_CONFIG.timezone,
        language:
          systemSettings?.language || DEFAULT_DATE_FORMATTER_CONFIG.language,
      }),
    [systemSettings]
  );
};
